<template>
  <div :class="computedClass">
    <v-tabs v-model="internalValue" :align-tabs="alignTabs" :fixed-tabs="fixedTabs" :grow="grow">
      <slot name="tabs" />
    </v-tabs>
    <v-tabs-window v-model="internalValue">
      <slot name="tab-items" />
    </v-tabs-window>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Boolean, String, Number, Array, Object],
      default: null,
    },

    alignTabs: {
      type: String,
      default: 'start',
      validator: (val) => ['start', 'center', 'end'].includes(val),
    },

    highlightBackground: {
      type: Boolean,
      default: false,
    },

    highlightBackgroundColor: {
      type: String,
      default: 'white',
      validator: (val) => ['white', 'brand', 'neutral'].includes(val),
    },

    fixedTabs: {
      type: Boolean,
      default: false,
    },

    grow: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },

      set(val) {
        this.$emit('update:modelValue', val);
      },
    },

    computedClass() {
      let classes = 'ag-tabs';

      if (this.highlightBackground) classes += ` ag-tabs--${this.highlightBackgroundColor}`;

      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/tabs';
</style>
